import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import OrderItemSuggested from '../../commons/orderItemSuggested';
import DisplaySuggestedImageDesktop from '../scanpack/displaySuggestedImageDesktop';
import placeholder from '../../../assets/placeholder.jpg';
import commonStyles from '../../style/commonStyles';
import globalStyles from '../../style/global';
import {fontFamily} from '../../helpers/fontFamily';

const LOCATIONS = [
  {key: 'L1', field: 'location', color: '#b6cadd'},
  {key: 'L2', field: 'location2', color: '#768da5'},
  {key: 'L3', field: 'location3', color: '#5a7792'}
];

const SuggestedCard = ({item, width, onItemPress}) => {
  const displayRow = LOCATIONS.filter(loc => item[loc.field]).map(loc => (
    <View key={loc.key} style={[styles.locationRow, {backgroundColor: loc.color}]}>
      <Text style={styles.locationLabel}>{loc.key} :</Text>
      <Text style={styles.locationValue}>{item[loc.field]}</Text>
    </View>
  ));

  const imageProps = {
    source: placeholder,
    defaultSource: placeholder,
    images: item.images || [],
    scannedQty: item.scanned_qty || 0,
    totalQty: (item.qty_remaining || 0) + (item.scanned_qty || 0),
    remainingQty: item.qty_remaining || 0,
    hideMenu: true,
    getWidth: () => (width >= 1450 ? 400 : 340),
    getMargin: () => '1.8rem'
  };

  return (
    <View style={commonStyles.nextItemRowFlex}>
      <OrderItemSuggested
        item={item}
        name={'productFirstSuggested'}
        testID={'putWallSuggested'}
        redirectToItemDetail={onItemPress}
        addBarcodeFun={() => {}}
        getFontSize={() => '40%'}
        width={width}
        displayRow={displayRow}
      />
      {width > 900 && <DisplaySuggestedImageDesktop {...imageProps} />}
    </View>
  );
};

const styles = StyleSheet.create({
  locationRow: {
    flexDirection: 'row',
    paddingVertical: 8,
    paddingHorizontal: 8,
    alignItems: 'center'
  },
  locationLabel: {
    fontSize: 18,
    paddingTop: 2,
    fontFamily: fontFamily.font400,
    ...globalStyles.nextItemText
  },
  locationValue: {
    fontSize: 28,
    textAlign: 'left',
    fontFamily: fontFamily.font700,
    ...globalStyles.nextItemText
  }
});

export default SuggestedCard;
